<template>
    <div class="animated fadeIn">
        <div>
            <component-header
                title="My Subscriptions"
                :isLoading="isloading"
                @reload-data="getPartnerSubcriptionListData"
                :hasCreate="false"
                :hasback="true"
                @back-press="$router.push('/myaccount')"
                @search-query="(val) => (filter = val)"
            />
            <b-card class="card-wrap" border-variant="info">
                <div>
                    <b-table
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive="sm"
                        :filter="filter"
                        :items="subscriptionItemList"
                        :fields="subscriptionColumns"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        show-empty
                    >
                        <template slot="cell(empty)">
                            <div v-if="isloading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                        <template slot="cell(status)" slot-scope="data">
                            <p v-if="data.item.status">
                                <img src="img/Ellipse63.png" alt="" /> Active
                            </p>
                            <p v-if="!data.item.status">
                                <img src="img/Ellipse6.png" alt="" /> Canceled
                            </p>
                        </template>
                    </b-table>
                </div>
                <div class="float-right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="subscriptionItemList.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
export default {
    name: "ViewSubscription",
    data() {
        return {
            filter: "",
            isloading: false,
            currentPage: 1,
            perPage: 8,
            subscriptionColumns: [
                {
                    key: "name",
                    sortable: true,
                },
                {
                    key: "startDate",
                },
                {
                    key: "invoicedUpto",
                },
                {
                    key: "nextBillDate",
                },
                {
                    key: "lastBillDate",
                },
                {
                    key: "rate",
                },
                {
                    key: "description",
                },
                {
                    key: "status",
                },
            ],
        };
    },
    components: {
        ebButton,
        ComponentHeader,
        loader,
    },
    computed: {
        ...mapGetters({
            subscriptionList: "subscription/GetSubscriptionList",
            partnerSubscribedList: "subscription/GetSubscriptionSellerMyList",
        }),
        subscriptionItemList() {
            let data = this.partnerSubscribedList;
            let subscriptionList = this.subscriptionList;
            let subscribedList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    try {
                        let selectedPlan = subscriptionList.filter(
                            (element) => {
                                return element._id == obj.plan;
                            },
                        );

                        let arrObj = {
                            _id: obj._id,
                            name: selectedPlan[0].planName,
                            startDate: this.getProperDate(obj.activationDate),
                            chargeTo: this.getProperDate(obj.chargeTo),
                            invoicedUpto: this.getProperDate(obj.chargeTo),
                            nextBillDate: this.getProperDate(obj.nextBillDate),
                            lastBillDate: this.getProperDate(obj.lastBillDate),
                            rate: this.cedencePriceSet(obj),
                            description: selectedPlan[0].planDescription,
                            status: obj.active,
                            restData: obj,
                        };
                        subscribedList.push(arrObj);
                    } catch (err) {}
                });
                return subscribedList.sort(
                    (a, b) =>
                        new Date(b.restData.updatedAt) -
                        new Date(a.restData.updatedAt),
                );
            } else {
                return [];
            }
        },
    },

    methods: {
        cedencePriceSet(obj) {
            if (obj.pricing.cadence == "EVENT") {
                return (obj.pricing.price * 100).toFixed(2);
            } else {
                return obj.pricing.price.toFixed(2);
            }
        },
        async getPartnerSubcriptionListData() {
            this.isloading = true;
            await this.$store
                .dispatch("subscription/fetchSubscriptionSellerMyList")
                .then((data) => {
                    if (data.message) {
                        this.$toasted.error(data.message);
                        this.isloading = false;
                    }
                    this.isloading = false;
                })
                .catch((err) => {
                    //
                });
        },
        getProperDate(data) {
            if (data != null) {
                let date = new Date(data);
                return moment(String(date)).format("DD/MM/YYYY");
            } else {
                return "Unavailable";
            }
        },
    },
    async mounted() {
        this.isloading = true;
        await this.$store.dispatch(
            "subscription/fetchSubscriptionSellerMyList",
        );
        await this.$store.dispatch("subscription/fetchSubscriptionList");
        this.isloading = false;
    },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
